// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Airtable = function Airtable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#airtable-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.936 1.688 1.475 4.775a.5.5 0 0 0 .007.927l7.492 2.971a2.78 2.78 0 0 0 2.05 0l7.492-2.971a.5.5 0 0 0 .007-.927l-7.461-3.087a2.78 2.78 0 0 0-2.126 0M10.664 10.296v7.422a.5.5 0 0 0 .684.465l8.349-3.24a.5.5 0 0 0 .316-.466V7.055a.5.5 0 0 0-.685-.465L10.98 9.831a.5.5 0 0 0-.316.465M8.714 10.678l-2.477 1.196-.252.121-5.23 2.507c-.332.16-.755-.082-.755-.45V7.085c0-.133.068-.248.16-.335a.6.6 0 0 1 .127-.095.53.53 0 0 1 .454-.035l7.932 3.143c.403.16.435.725.041.915"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airtable-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
